import axios from "axios";
import endpoints from "@/api/endpoints";

export class BugreportService {
  static __instance = null;

  constructor() {
    if (BugreportService.__instance) {
      return BugreportService.__instance;
    }

    BugreportService.__instance = this;
  }

  submit(data) {
    return axios.post(endpoints.bugreport, data).then(response => {
      if (response.data.success) {
        return response;
      } else throw new Error();
    });
  }
}

export const bugreportService = new BugreportService();
